const atomy = {
    host: {          
        api :"https://mq2zyc5ewh.execute-api.ap-southeast-1.amazonaws.com/atomy-sg"
    },
    cdnEndpoint: "https://d2j9cuvjyuu4c0.cloudfront.net/",
    playerEndpoint: "https://d2moldzjnrveq2.cloudfront.net/",
    deployDestination: "s3://mzc-cm-atomy-sg-shared-videos",
    
    profile: "mzc-media-atomy-prod"
};

export default atomy;
